import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ACL_WTAX_LINE_COLUMNS } from '@core';

@Component({
  selector: 'app-ar-wtax-knockoff',
  templateUrl: './wtax-knockoff.component.html',
  styles: [],
  standalone: false
})
export class ARWtaxKnockoffComponent implements OnInit {
  readonly aclWtaxLineColumns = ACL_WTAX_LINE_COLUMNS;

  constructor(private fb: FormBuilder) {}

  private _observeChanges = false;
  @Input() data: any[] = [];
  visible = false;
  form = this.fb.group({
    details: this.fb.array([this.createLine()])
  });
  get details() {
    return this.form.controls.details;
  }
  ngOnInit(): void {
    let count = this.data?.length ?? 0;
    this.details.clear();
    this._observeChanges = false;
    for (let i = 0; i < count; i++) {
      let line = this.createLine();
      line.patchValue(this.data[i]);
      this.details.push(line);
    }
    this._observeChanges = true;
  }

  handleOk() {}
  handleCancel() {}

  addLine() {
    this.details.push(this.createLine());
  }

  removeLine(index: number) {
    this.details.removeAt(index);
  }

  get totalWTaxAmount() {
    let total = 0;
    this.details.value.forEach(item => {
      total += <number>item.wTaxAmount;
    });
    return total;
  }

  private createLine() {
    const line = this.fb.group({
      wTaxCodeId: [<any>null, []],
      wTaxCode: [<any>null, [Validators.required]],
      paymentAmount: [0, []],
      wTaxAmount: [<number>0, []]
    });

    line.controls.paymentAmount.valueChanges.subscribe(val => {
      if (!this._observeChanges) return;

      this._observeChanges = false;
      line.value.paymentAmount = val;
      this.recalculate(line);
      this._observeChanges = true;
    });
    line.controls.wTaxCode.valueChanges.subscribe(val => {
      if (!this._observeChanges) return;
      this._observeChanges = false;
      line.controls.wTaxCodeId.setValue(val?.id);
      this.recalculate(line);
      this._observeChanges = true;
    });

    return line;
  }

  private recalculate(line: FormGroup) {
    let rate = 0;
    let amount = 0;
    if (line.controls['wTaxCode'].value) {
      rate = line.controls['wTaxCode'].value.rate;
    }
    if (line.controls['paymentAmount'].value) {
      amount = line.controls['paymentAmount'].value;
    }

    const wtaxAmount = Math.round(rate * amount * 100) / 100;

    line.controls['wTaxAmount'].setValue(wtaxAmount);
  }
}
